import { z } from "https://esm.sh/zod@3.23.8";
// --- Captura e persistência de UTM/gclid (first-touch, 30 dias) ---
(function () {
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'];
  const STORAGE_KEY = 'mtx_utm_data';
  const EXPIRY_DAYS = 30;

  function getStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (Date.now() > parsed.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function captureUTM() {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    let hasAny = false;
    UTM_KEYS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        found[key] = val;
        hasAny = true;
      }
    });

    // Só sobrescreve se a URL atual trouxer UTM novo (first-touch preservado se não vier nada)
    if (hasAny) {
      found.landing_page = window.location.href;
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          data: found,
          expires: Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000,
        })
      );
    }
  }

  captureUTM();

  window.getMetaltexUTM = function () {
    return getStored() || {};
  };
})();
/** Miniatura (160px) da imagem de um item do /cart.js; usada na lista de Meus orçamentos. */
function cartItemImage(src) {
  if (!src) return "";
  try {
    const url = new URL(src, window.location.origin);
    url.searchParams.set("width", "160");
    return url.toString();
  } catch (_e) {
    return String(src);
  }
}

const BudgetForm = {
  svgSuccess:
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>',

  svgError:
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path d="M236.8,188.09,149.35,36.22a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z"></path></svg>',

  form: null,
  schema: null,
  i18n: {},
  endpoint: "",
  msgSuccess: "",
  msgError: "",
  blockId: "",
  statusEl: null,
  submitBtn: null,
  fileInput: null,
  fileNameEl: null,

  parseI18n(form) {
    try {
      return JSON.parse(form.getAttribute("data-i18n") || "{}");
    } catch (_e) {
      return {};
    }
  },

  buildSchema(i18n) {
    return z.object({
      name: z.string().min(1, i18n.name || "Informe o nome."),
      email: z
        .string()
        .min(1, i18n.email || "Informe o e-mail.")
        .email(i18n.email_invalid || "E-mail inválido."),
      telefone: z.string().min(1, i18n.phone || "Informe o telefone."),
      empresa: z.string().min(1, i18n.company || "Informe a empresa."),
      cnpj: z.string().min(1, i18n.cnpj || "Informe o CNPJ."),
      cidade: z.string().min(1, i18n.city || "Informe a cidade."),
      estado: z.string(),
      pais: z.string().min(1, i18n.country || "Selecione o país."),
      segmento: z.string().min(1, i18n.segment || "Selecione o segmento."),
      atividade: z.string().min(1, i18n.activity || "Selecione a atividade."),
      mensagem: z.string(),
      marketing_opt_in: z.boolean(),
      lgpd_consent: z.enum(["aceito", "nao_aceito"], {
        errorMap: function () {
          return { message: i18n.lgpd || "Selecione uma opção." };
        },
      }),
    });
  },

  init() {
    this.form = document.getElementById("budget-form");
    if (!this.form || this.form.dataset.budgetInit === "1") return;
    this.form.dataset.budgetInit = "1";

    this.endpoint = this.form.getAttribute("data-budget-endpoint") || "";
    if (!this.endpoint) return;

    this.msgSuccess = this.form.getAttribute("data-msg-success") || "";
    this.msgError = this.form.getAttribute("data-msg-error") || "";
    this.blockId = this.form.getAttribute("data-budget-block-id") || "";
    this.i18n = this.parseI18n(this.form);
    this.schema = this.buildSchema(this.i18n);

    this.statusEl = document.getElementById("budget-form-status");
    this.submitBtn = document.getElementById("budget-submit-" + this.blockId);
    this.pdfBtn = document.getElementById("budget-pdf-" + this.blockId);
    this.fileInput = document.getElementById("budget-file-" + this.blockId);
    this.fileNameEl = document.getElementById(
      "budget-file-name-" + this.blockId,
    );
    this.pdfI18n = this.parsePdfI18n(this.form);

    this.attachListeners();
    this.enableSubmitButton();
    this.applyProfile();
  },

  /** Campos do cadastro gravados no perfil do cliente e reaproveitados nos próximos orçamentos. */
  profileFields: ["name", "telefone", "empresa", "cnpj", "cidade", "estado", "pais", "segmento", "atividade"],

  /** Campo do formulário -> chave do metacampo de cliente (custom.<chave>) gravado pelo n8n. */
  profileMetafieldKeys: {
    telefone: "phone",
    empresa: "company",
    cnpj: "cnpj",
    cidade: "city",
    estado: "state",
    pais: "country",
    segmento: "segment",
    atividade: "activity",
  },

  /** Perfil salvo na conta (metacampos custom.*), válido em qualquer dispositivo. */
  loadProfile() {
    let remote = {};
    try {
      // Versões anteriores guardavam uma cópia no navegador: não guardamos mais.
      localStorage.removeItem("mtxPerfilOrcamento:" + this.form.dataset.customerId);
    } catch (_e) {
      /* storage indisponível */
    }
    try {
      const el = document.getElementById("budget-customer-profile");
      remote = (el && JSON.parse(el.textContent)) || {};
    } catch (_e) {
      remote = {};
    }
    const profile = {};
    this.profileFields.forEach((key) => {
      const value = remote[key];
      if (typeof value === "string" && value.trim()) profile[key] = value.trim();
    });
    return profile;
  },

  /** Preenche apenas os campos vazios; não sobrescreve o que o cliente já digitou. */
  applyProfile() {
    if (!this.form.dataset.customerId) return;
    const profile = this.loadProfile();
    Object.keys(profile).forEach((key) => {
      const field = this.form.elements[key];
      if (!field || field.value) return;
      if (field.tagName === "SELECT") {
        const exists = Array.prototype.some.call(field.options, (o) => o.value === profile[key]);
        if (!exists) return;
      }
      field.value = profile[key];
    });
  },

  profileFromPayload(payload) {
    const profile = {};
    this.profileFields.forEach((key) => {
      const value = payload.get(key);
      if (typeof value === "string" && value.trim()) profile[key] = value.trim();
    });
    return profile;
  },

  toMetafieldProfile(profile) {
    const out = {};
    Object.keys(this.profileMetafieldKeys).forEach((field) => {
      if (profile[field]) out[this.profileMetafieldKeys[field]] = profile[field];
    });
    return out;
  },

  parsePdfI18n(form) {
    try {
      return JSON.parse(form.getAttribute("data-pdf-i18n") || "{}");
    } catch (_e) {
      return {};
    }
  },

  selectLabel(name) {
    const sel = this.form.querySelector('[name="' + name + '"]');
    if (!sel || !sel.selectedOptions || !sel.selectedOptions.length) return "";
    const text = String(sel.selectedOptions[0].textContent || "").trim();
    if (!text || !sel.value) return "";
    return text;
  },

  escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  },

  getCartItems() {
    try {
      return JSON.parse(
        this.form.getAttribute("data-budget-cart-items") || "[]",
      );
    } catch (_e) {
      return [];
    }
  },

  buildPdfHtml() {
    const t = this.pdfI18n;
    const data = this.parseFormData(this.form);
    const items = this.getCartItems();
    const now = new Date().toLocaleString();
    let logo = this.form.getAttribute("data-pdf-logo") || "";
    if (logo.indexOf("//") === 0) logo = "https:" + logo;

    const infoRow = (label, valueHtml) => {
      if (!valueHtml) return "";
      return (
        '<div class="info-row"><span class="info-label">' +
        this.escapeHtml(label) +
        "</span> " +
        valueHtml +
        "</div>"
      );
    };

    const contactRow = (label, value) => {
      const v = String(value || "").trim();
      if (!v) return "";
      return (
        '<div class="contact-row"><span>' +
        this.escapeHtml(label) +
        '</span><strong>' +
        this.escapeHtml(v) +
        "</strong></div>"
      );
    };

    let productsHtml = "";
    if (items.length) {
      productsHtml = items
        .map((item) => {
          const meta = [];
          if (item.variant_title) meta.push(item.variant_title);
          if (item.sku) meta.push((t.sku || "SKU") + ": " + item.sku);
          let imageUrl = item.image || "";
          if (imageUrl.indexOf("//") === 0) imageUrl = "https:" + imageUrl;
          const img = imageUrl
            ? '<img src="' +
              this.escapeHtml(imageUrl) +
              '" alt="" width="56" height="56">'
            : '<div class="thumb-placeholder"></div>';
          return (
            '<div class="product-row">' +
            '<div class="product-main">' +
            img +
            '<div class="product-info">' +
            '<div class="product-title">' +
            this.escapeHtml(item.title || "") +
            "</div>" +
            (meta.length
              ? '<div class="product-meta">' +
                this.escapeHtml(meta.join(" · ")) +
                "</div>"
              : "") +
            "</div></div>" +
            '<div class="product-qty"><span class="pill">' +
            this.escapeHtml(String(item.quantity || 1)) +
            "</span></div>" +
            "</div>"
          );
        })
        .join("");
    } else {
      productsHtml =
        '<p class="empty">' + this.escapeHtml(t.empty || "—") + "</p>";
    }

    const contactHtml = [
      contactRow(t.name, data.name),
      contactRow(t.email, data.email),
      contactRow(t.phone, data.telefone),
      contactRow(t.company, data.empresa),
      contactRow(t.cnpj, data.cnpj),
      contactRow(t.city, data.cidade),
      contactRow(t.state, data.estado),
      contactRow(t.country, this.selectLabel("pais")),
      contactRow(t.segment, this.selectLabel("segmento")),
      contactRow(t.activity, this.selectLabel("atividade")),
      contactRow(t.message, data.mensagem),
    ].join("");

    const logoHtml = logo
      ? '<img class="logo" src="' +
        this.escapeHtml(logo) +
        '" alt="Metaltex">'
      : '<div class="logo-text">Metaltex</div>';

    return `<!doctype html>
<html lang="${this.escapeHtml(document.documentElement.lang || "pt-BR")}">
<head>
  <meta charset="utf-8">
  <title>${this.escapeHtml(t.title || "Meu orçamento")}</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: Arial, Helvetica, sans-serif;
      color: #1a1a1a;
      margin: 0;
      padding: 28px 32px 40px;
      font-size: 13px;
      line-height: 1.45;
      background: #fff;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 22px;
      padding-bottom: 16px;
      border-bottom: 1px solid #e8e8e8;
    }
    .logo { max-width: 180px; max-height: 52px; object-fit: contain; }
    .logo-text { font-size: 22px; font-weight: 700; color: #ef7d00; }
    .header h1 { margin: 0; font-size: 26px; font-weight: 700; letter-spacing: -0.02em; }
    .box {
      background: #f4f4f4;
      border-radius: 10px;
      padding: 16px 18px;
      margin-bottom: 22px;
    }
    .box h2 {
      margin: 0 0 10px;
      font-size: 15px;
      font-weight: 700;
    }
    .box-intro {
      margin: -4px 0 12px;
      color: #666;
      font-size: 12px;
    }
    .info-row { margin: 4px 0; }
    .info-label { font-weight: 700; }
    .info-row a { color: #1c52d7; word-break: break-all; }
    .products-head {
      display: grid;
      grid-template-columns: 1fr 110px;
      gap: 12px;
      padding: 0 4px 10px;
      border-bottom: 1px solid #e5e5e5;
      color: #666;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.02em;
    }
    .products-head span:last-child { text-align: center; }
    .product-row {
      display: grid;
      grid-template-columns: 1fr 110px;
      gap: 12px;
      align-items: center;
      padding: 14px 4px;
      border-bottom: 1px solid #ececec;
    }
    .product-main { display: flex; align-items: center; gap: 12px; min-width: 0; }
    .product-main img,
    .thumb-placeholder {
      width: 56px;
      height: 56px;
      border-radius: 6px;
      object-fit: contain;
      background: #f7f7f7;
      border: 1px solid #ececec;
      flex-shrink: 0;
    }
    .product-title { font-weight: 600; }
    .product-meta { color: #777; font-size: 12px; margin-top: 2px; }
    .product-qty { display: flex; justify-content: center; }
    .pill {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 42px;
      padding: 6px 12px;
      border-radius: 999px;
      background: #f0f0f0;
      font-weight: 600;
    }
    .empty { color: #777; padding: 16px 4px; }
    .contact-row {
      display: flex;
      justify-content: space-between;
      gap: 16px;
      padding: 8px 0;
      border-bottom: 1px solid #e8e8e8;
    }
    .contact-row:last-child { border-bottom: 0; }
    .contact-row span { color: #666; }
    .contact-row strong { text-align: right; font-weight: 600; }
    @media print {
      body { padding: 12px 16px; }
      .box { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  <header class="header">
    ${logoHtml}
    <h1>${this.escapeHtml(t.title || "Meu orçamento")}</h1>
  </header>

  <section class="box">
    <h2>${this.escapeHtml(t.quote_data || "Dados do orçamento")}</h2>
    ${infoRow(t.generated_at || "Data da geração:", "<strong>" + this.escapeHtml(now) + "</strong>")}
  </section>

  <section class="products">
    <div class="products-head">
      <span>${this.escapeHtml(t.product || "Produto")}</span>
      <span>${this.escapeHtml(t.qty || "Quantidade")}</span>
    </div>
    ${productsHtml}
  </section>

  ${
    contactHtml
      ? `<section class="box" style="margin-top:22px">
    <h2>${this.escapeHtml(t.contact || "Dados do solicitante")}</h2>
    <p class="box-intro">${this.escapeHtml(t.contact_intro || "")}</p>
    ${contactHtml}
  </section>`
      : ""
  }
</body>
</html>`;
  },

  getPrintFrame() {
    let frame = document.getElementById("budget-pdf-print-frame");
    if (!frame) {
      frame = document.createElement("iframe");
      frame.id = "budget-pdf-print-frame";
      frame.title = "budget-pdf-print";
      frame.setAttribute("aria-hidden", "true");
      frame.style.cssText =
        "position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none;";
      document.body.appendChild(frame);
    }
    return frame;
  },

  onPrintPdf(e) {
    if (e) e.preventDefault();
    const html = this.buildPdfHtml();
    const frame = this.getPrintFrame();
    const frameWindow = frame.contentWindow;
    if (!frameWindow) return;

    const frameDoc = frameWindow.document;
    frameDoc.open();
    frameDoc.write(html);
    frameDoc.close();

    const triggerPrint = function () {
      try {
        frameWindow.focus();
        frameWindow.print();
      } catch (_err) {
        // ignore
      }
    };

    // Wait for images (logo/products) before printing so layout stays intact.
    const images = Array.prototype.slice.call(frameDoc.images || []);
    if (!images.length) {
      setTimeout(triggerPrint, 50);
      return;
    }

    let pending = images.length;
    const done = function () {
      pending -= 1;
      if (pending <= 0) setTimeout(triggerPrint, 50);
    };

    images.forEach(function (img) {
      if (img.complete) {
        done();
        return;
      }
      img.addEventListener("load", done, { once: true });
      img.addEventListener("error", done, { once: true });
    });
  },

  parseFormData(form) {
    const fd = new FormData(form);
    const utmData = window.getMetaltexUTM();
    return {
      name: String(fd.get("name") ?? "").trim(),
      email: String(fd.get("email") ?? "").trim(),
      telefone: String(fd.get("telefone") ?? "").trim(),
      empresa: String(fd.get("empresa") ?? "").trim(),
      cnpj: String(fd.get("cnpj") ?? "").trim(),
      cidade: String(fd.get("cidade") ?? "").trim(),
      estado: String(fd.get("estado") ?? "").trim(),
      pais: String(fd.get("pais") ?? ""),
      segmento: String(fd.get("segmento") ?? ""),
      atividade: String(fd.get("atividade") ?? ""),
      mensagem: String(fd.get("mensagem") ?? "").trim(),
      marketing_opt_in: fd.get("marketing_opt_in") === "yes",
      lgpd_consent: String(fd.get("lgpd_consent") ?? ""),
      utm_source: utmData.utm_source || "",
      utm_medium: utmData.utm_medium || "",
      utm_campaign: utmData.utm_campaign || "",
      utm_content: utmData.utm_content || "",
      utm_term: utmData.utm_term || "",
      gclid: utmData.gclid || "",
    };
  },

  validate(formEl) {
    const el = formEl || this.form;
    return this.schema.safeParse(this.parseFormData(el));
  },

  clearFieldErrors() {
    this.form
      .querySelectorAll(".budget-form__field-error")
      .forEach(function (el) {
        el.textContent = "";
        el.hidden = true;
      });
  },

  clearErrorForField(name) {
    if (!name) return;
    const el = this.form.querySelector(
      '.budget-form__field-error[data-budget-field="' + name + '"]',
    );
    if (el) {
      el.textContent = "";
      el.hidden = true;
    }
  },

  showZodFieldErrors(zodError) {
    const fe = zodError.flatten().fieldErrors;
    const form = this.form;
    Object.keys(fe).forEach(function (key) {
      const messages = fe[key];
      if (!messages || !messages.length) return;
      const errEl = form.querySelector(
        '.budget-form__field-error[data-budget-field="' + key + '"]',
      );
      if (errEl) {
        errEl.textContent = messages[0];
        errEl.hidden = false;
      }
    });
  },

  focusFirstInvalidField(zodError) {
    const issue = zodError.issues[0];
    if (!issue || !issue.path || !issue.path.length) return;
    const key = String(issue.path[0]);
    const control =
      this.form.querySelector('[name="' + key + '"]') ||
      (key === "lgpd_consent"
        ? this.form.querySelector('[name="lgpd_consent"]')
        : null);
    if (control && typeof control.focus === "function") {
      control.focus();
    }
  },

  cartJsUrl() {
    let root =
      typeof window.Shopify !== "undefined" &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    if (root.slice(-1) !== "/") root += "/";
    return root + "cart.js";
  },

  mapCartItems(items) {
    return items.map(function (item) {
      const variantTitle =
        item.variant_title != null &&
        item.variant_title !== "" &&
        item.variant_title !== "Default Title"
          ? String(item.variant_title)
          : "";
      const productTitle =
        item.product_title != null && item.product_title !== ""
          ? String(item.product_title)
          : item.title != null
            ? String(item.title)
            : "";

      return {
        quantity: item.quantity,
        sku: item.sku != null && item.sku !== "" ? String(item.sku) : "",
        title: productTitle,
        variant_title: variantTitle,
        variant_id: item.variant_id != null ? item.variant_id : "",
        product_id: item.product_id != null ? item.product_id : "",
        handle: item.handle != null ? String(item.handle) : "",
        image: cartItemImage(item.image),
      };
    });
  },

  getEmbeddedCartItems() {
    const raw = this.form.getAttribute("data-budget-cart-items");
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed) || parsed.length === 0) return null;
      return parsed;
    } catch {
      return null;
    }
  },

  async fetchCartItems() {
    const url = this.cartJsUrl();
    try {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) return null;
      const cart = await res.json();
      if (!cart.items || !Array.isArray(cart.items) || cart.items.length === 0)
        return null;
      return this.mapCartItems(cart.items);
    } catch {
      return null;
    }
  },

  async resolveCartItems() {
    const fetched = await this.fetchCartItems();
    if (fetched && fetched.length) return fetched;
    return this.getEmbeddedCartItems() || [];
  },

  /**
   * Monta o FormData manualmente para NÃO incluir o input file vazio.
   * O parser multipart do n8n interrompe os campos seguintes (items, lgpd, etc.)
   * quando recebe uma parte file sem conteúdo.
   */
  async buildPayload() {
    const parsed = this.parseFormData(this.form);
    const data = new FormData();

    Object.keys(parsed).forEach((key) => {
      const value = parsed[key];
      if (key === "marketing_opt_in") {
        data.append(key, value ? "yes" : "no");
      } else {
        data.append(key, value);
      }
    });

    if (this.fileInput && this.fileInput.files && this.fileInput.files.length > 0) {
      data.append("file", this.fileInput.files[0]);
    }

    const items = await this.resolveCartItems();
    data.append("items", JSON.stringify(items));
    data.append("submitted_at", new Date().toISOString());
    data.append("source_url", window.location.href);

    const utm = window.getMetaltexUTM ? window.getMetaltexUTM() : {};
    data.append(
      "utms",
      JSON.stringify({
        utm_source: utm.utm_source || null,
        utm_medium: utm.utm_medium || null,
        utm_campaign: utm.utm_campaign || null,
        utm_term: utm.utm_term || null,
        utm_content: utm.utm_content || null,
      }),
    );
    data.append("utm_landing_page", utm.landing_page || "");
    if (this.form.dataset.customerId) {
      data.append("customer_id", this.form.dataset.customerId);
      data.append("customer_email", this.form.dataset.customerEmail || "");
      // Para o n8n gravar nos metacampos de cliente custom.* (chaves já no formato do metacampo).
      data.append("customer_profile", JSON.stringify(this.toMetafieldProfile(this.profileFromPayload(data))));
    }
    return data;
  },

  /**
   * Monta o registro do orçamento enviado (id, itens, dados). Não fica no navegador:
   * vai no link da página do app, que grava em custom.quotes_history (e numera).
   */
  buildQuoteRecord(payload) {
    if (!this.form.dataset.customerId) return null;
    try {
      const id = Date.now().toString(36);
      const items = JSON.parse(payload.get("items") || "[]").map((item) => ({
        title: item.title || "",
        variant_title: item.variant_title || "",
        sku: item.sku || "",
        quantity: item.quantity || 0,
        image: item.image || "",
        handle: item.handle || "",
        variant_id: item.variant_id || "",
      }));
      const file = this.fileInput && this.fileInput.files[0];
      return {
        id,
        submitted_at: payload.get("submitted_at"),
        name: payload.get("name") || "",
        email: payload.get("email") || "",
        telefone: payload.get("telefone") || "",
        empresa: payload.get("empresa") || "",
        cnpj: payload.get("cnpj") || "",
        cidade: payload.get("cidade") || "",
        estado: payload.get("estado") || "",
        pais: this.selectLabel("pais"),
        segmento: this.selectLabel("segmento"),
        atividade: this.selectLabel("atividade"),
        mensagem: payload.get("mensagem") || "",
        arquivo: file ? file.name : "",
        items,
      };
    } catch (_e) {
      return null;
    }
  },

  /** Códigos de orçamentos excluídos em Meus orçamentos que ainda estão na conta. */
  pendingDeletes() {
    try {
      const ids = JSON.parse(localStorage.getItem("mtxOrcamentosExcluidos:" + this.form.dataset.customerId) || "[]");
      return Array.isArray(ids) ? ids.map(String) : [];
    } catch (_e) {
      return [];
    }
  },

  /** JSON -> base64url (UTF-8), para ir no link da página da conta. */
  encodeForUrl(value) {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = "";
    bytes.forEach((b) => {
      binary += String.fromCharCode(b);
    });
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  },

  /**
   * Link para a página "Salvar orçamento na conta" (app metaltex-orcamentos), que grava
   * sozinha os dados da empresa e o orçamento na conta e oferece voltar para returnPath.
   * Sem a página configurada (ou sem cliente logado), devolve returnPath direto.
   */
  accountSaveLink(record, profile, returnPath, newQuotePath) {
    const base = this.form.dataset.accountSaveUrl;
    if (!base || !record) return returnPath;
    const payload = {
      v: 1,
      ts: Date.now(),
      r: window.location.origin + returnPath,
      n: newQuotePath ? window.location.origin + newQuotePath : undefined,
      del: this.pendingDeletes(),
      p: profile,
      q: {
        ...record,
        items: (record.items || []).map((item) => ({
          title: item.title,
          variant_title: item.variant_title,
          sku: item.sku,
          quantity: item.quantity,
          handle: item.handle,
          variant_id: item.variant_id,
        })),
      },
    };
    const url = new URL(base, window.location.origin);
    url.searchParams.set("d", this.encodeForUrl(payload));
    return url.toString();
  },

  /** Esvazia todos os campos (inclusive os que vêm pré-preenchidos da conta). */
  clearFields() {
    this.form.reset();
    this.form.querySelectorAll("input, textarea, select").forEach((field) => {
      if (field.type === "hidden") return;
      if (field.type === "checkbox" || field.type === "radio") field.checked = false;
      else field.value = "";
    });
    if (this.fileNameEl) {
      this.fileNameEl.textContent = this.i18n.attach_file || "Anexar arquivo";
    }
    this.clearFieldErrors();
  },

  /** Modal "Orçamento enviado" com "Fazer novo orçamento" e "Ver meus orçamentos". */
  showSuccessModal(record, profile) {
    const modal = document.getElementById("BudgetSuccessModal-" + this.blockId);
    if (!modal || typeof modal.showModal !== "function") {
      this.showStatus("success");
      return;
    }
    const newBtn = modal.querySelector("[data-budget-success-new]");
    const quotesBtn = modal.querySelector("[data-budget-success-quotes]");
    if (newBtn) newBtn.href = this.accountSaveLink(record, profile, newBtn.dataset.path);
    if (quotesBtn) quotesBtn.href = this.accountSaveLink(record, profile, quotesBtn.dataset.path);
    // Sem localStorage, fechar o modal também passa pela conta (senão o orçamento some do histórico).
    const cartPath = window.location.pathname;
    const closeLink = this.accountSaveLink(record, profile, cartPath);
    modal.dataset.closeHref = closeLink !== cartPath ? closeLink : "";
    if (this.statusEl) this.statusEl.hidden = true;
    modal.showModal();
    modal.focus();
  },

  bindSuccessModal() {
    const modal = document.getElementById("BudgetSuccessModal-" + this.blockId);
    if (!modal) return;
    modal.querySelectorAll("[data-budget-success-close]").forEach((btn) => {
      btn.addEventListener("click", () => modal.close());
    });
    modal.addEventListener("click", (e) => {
      if (e.target === modal) modal.close();
    });
    modal.addEventListener("close", () => {
      if (modal.dataset.closeHref) window.location.href = modal.dataset.closeHref;
    });
  },

  /**
   * Após o envio, esvazia o carrinho: os produtos já foram para o orçamento e
   * não devem continuar na lista como se não tivessem sido enviados.
   */
  async clearCart() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const res = await fetch(root + "cart/clear.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (!res.ok) return;
      const cart = await res.json();

      // Contador do header / minicart (mesmo evento usado pelo cart.js do tema).
      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      }
      document.querySelectorAll("cart-count").forEach((el) => {
        el.hidden = true;
      });

      // Lista de produtos do formulário no /cart.
      const products = document.querySelector(".budget-form__products");
      if (products) products.hidden = true;
      this.form.setAttribute("data-budget-cart-items", "[]");
    } catch (_e) {
      /* se falhar, o orçamento já foi enviado; o carrinho só não é limpo */
    }
  },

  showStatus(type) {
    if (!this.statusEl) return;
    const text = type === "success" ? this.msgSuccess : this.msgError;
    this.statusEl.innerHTML = "";
    this.statusEl.hidden = false;

    const wrapper = document.createElement("div");
    wrapper.className =
      type === "success"
        ? "form-message alert alert--success h6 blocks-radius"
        : "form-error alert alert--error blocks-radius";
    wrapper.setAttribute("role", type === "success" ? "status" : "alert");
    wrapper.setAttribute("tabindex", "-1");

    const icon = document.createElement("span");
    icon.innerHTML = type === "success" ? this.svgSuccess : this.svgError;
    wrapper.appendChild(icon);
    wrapper.appendChild(document.createTextNode(" " + text));
    const quotesUrl = this.form.dataset.quotesUrl;
    if (type === "success" && quotesUrl && this.lastQuoteId) {
      const link = document.createElement("a");
      link.href = quotesUrl + "?orcamento=" + encodeURIComponent(this.lastQuoteId);
      link.className = "budget-form__status-link";
      link.textContent = this.form.dataset.quotesLabel || "Ver orçamento";
      wrapper.appendChild(document.createTextNode(" "));
      wrapper.appendChild(link);
    }
    this.statusEl.appendChild(wrapper);
    wrapper.focus();
    this.statusEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
  },
  /** Evento do GTM (orcamento_sucesso_interno -> GA4 form_orcamento). Nunca bloqueia o fluxo. */
  trackQuoteSuccess(quoteId) {
    return new Promise((resolve) => {
      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        resolve();
      };
      try {
        if (window.__orcamentoSuccessFired) return finish();
        window.__orcamentoSuccessFired = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "orcamento_sucesso_interno",
          quote_id: quoteId || "",
          eventCallback: finish,
          eventTimeout: 1500,
        });
        setTimeout(finish, 800);
      } catch (_e) {
        finish();
      }
    });
  },
  async postBudgetForm(payload) {
    const res = await fetch(this.endpoint, {
      method: "POST",
      body: payload,
    });

    let body = {};
    try {
      body = await res.json();
    } catch {
      body = {};
    }

    if (!res.ok) {
      throw new Error(body.message || "Erro " + res.status);
    }

    return body;
  },

  setLoading(isLoading) {
    if (!this.submitBtn) return;
    const btnText = this.submitBtn.querySelector(".btn__text");
    const spinner = this.submitBtn.querySelector(".budget-form__spinner");
    if (btnText) btnText.hidden = isLoading;
    if (spinner) spinner.hidden = !isLoading;
    if (isLoading) {
      this.submitBtn.disabled = true;
    } else {
      this.enableSubmitButton();
    }
  },

  /** O envio só é bloqueado durante o request (loading); a validação Zod corre sempre no submit. */
  enableSubmitButton() {
    if (this.submitBtn) this.submitBtn.disabled = false;
  },

  onFileChange() {
    if (!this.fileInput || !this.fileNameEl) return;
    this.fileNameEl.textContent =
      this.fileInput.files.length > 0
        ? this.fileInput.files[0].name
        : this.i18n.attach_file || "Anexar arquivo";
  },

  onFieldInput(e) {
    const t = e.target;
    if (t && t.name) this.clearErrorForField(t.name);
  },

  onFieldChange(e) {
    const t = e.target;
    if (t && t.name) this.clearErrorForField(t.name);
  },

  async onSubmit(e) {
    e.preventDefault();
    const formEl = e.currentTarget;
    this.clearFieldErrors();

    if (formEl.dataset.budgetRequiresAuth === "true") {
      // Sem login: vai para o login do Shopify e volta para o /cart depois.
      if (formEl.dataset.loginUrl) window.location.href = formEl.dataset.loginUrl;
      return;
    }

    const result = this.validate(formEl);
    if (!result.success) {
      this.showZodFieldErrors(result.error);
      this.focusFirstInvalidField(result.error);
      this.enableSubmitButton();
      return;
    }

    this.setLoading(true);
    if (this.statusEl) this.statusEl.hidden = true;

    try {
      const payload = await this.buildPayload();
      await this.postBudgetForm(payload);
      const record = this.buildQuoteRecord(payload);
      this.lastQuoteId = record ? record.id : null;
      await this.trackQuoteSuccess(this.lastQuoteId);
      const profile = this.profileFromPayload(payload);
      const sentItems = JSON.parse(payload.get("items") || "[]");
      if (sentItems.length) await this.clearCart();
      this.clearFields();
      // n8n respondeu 200: grava na conta já. A página do app é a tela de sucesso
      // ("Fazer novo orçamento" / "Ver meus orçamentos"). Sem ela, usa o modal.
      const quotesPath = this.form.dataset.quotesUrl || "/pages/meus-orcamentos";
      const saveUrl = this.accountSaveLink(
        record,
        this.toMetafieldProfile(profile),
        quotesPath,
        this.form.dataset.newQuoteUrl || "/collections/all",
      );
      if (saveUrl !== quotesPath) {
        window.location.href = saveUrl;
        return;
      }
      this.showSuccessModal(record, this.toMetafieldProfile(profile));
    } catch {
      this.showStatus("error");
    } finally {
      this.setLoading(false);
    }
  },

  attachListeners() {
    if (this.fileInput && this.fileNameEl) {
      this.fileInput.addEventListener("change", () => this.onFileChange());
    }
    if (this.pdfBtn) {
      this.pdfBtn.addEventListener("click", (e) => this.onPrintPdf(e));
    }
    this.form.addEventListener("input", (e) => this.onFieldInput(e));
    this.form.addEventListener("change", (e) => this.onFieldChange(e));
    this.form.addEventListener("submit", (e) => this.onSubmit(e));
    this.bindSuccessModal();
  },
};

BudgetForm.init();

export { BudgetForm };
